"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.997 11.997a8 8 0 1 1 16 0 8 8 0 0 1-16 0M12.5 8a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M12 9.5a.5.5 0 0 0-.5.5v5a.5.5 0 1 0 1 0v-5a.5.5 0 0 0-.5-.5"
}), 'InfoCircleFilled');
